export const STRIPE_PUBLIC_KEY =
  "pk_test_51JY6PhLMNScNihm2r2ms6IuvF0QWfZDidSQcyDczOasnFVfxTi4zLiBBi4fFccrvYoyvBbzlmmeBtSchOxa7TUKW00AThIuMFN";
export const STRIPE_CLIENT_ID = "ca_L4SpeOCcmkBQsgSOw653kOzZjkn0S6qr";

export const STRIPE_PUBLIC_KEY_PROD =
  "pk_live_51JY6PhLMNScNihm2OSYmC2a42H59tZ9yoUqk43hBHy13hzZVizwvb9f0G5lf4OvggoJXuZr5PhFgwhihMB49RFrJ004rXjWkLa";
export const STRIPE_CLIENT_ID_PROD = "ca_L4SpMpuRKPUKYt0b5YL05hR9jaLD48I5";

export const STRIPE_REDIRECT_URI = `${process.env.REACT_APP_KATOMI_API_URL}v1/doctors/stripeAcc`;
